var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenArchive = function SvgOpenArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.06 24.18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".open-archive_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-archive_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-archive_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.52 4.14a1 1 0 0 1-.7 1.22L2.54 10.83a1 1 0 0 1-1.22-.7l-.79-2.9A1 1 0 0 1 1.24 6L21.52.53a1 1 0 0 1 1.22.71ZM23.56 12.68v10a1 1 0 0 1-1 1h-19a1 1 0 0 1-1-1v-10",
    className: "open-archive_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56 15.18a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1 0-3h4a1.5 1.5 0 0 1 1.5 1.5",
    className: "open-archive_svg__cls-1"
  })))));
};
export default SvgOpenArchive;